import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { G4SustainAnalyticsEditCard } from "./edit_card";
import { Tables } from "../../../gen/tableNames/tables";
import { Clients } from "../../../lib/clients";

export const G4SustainAnalyticsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full relative">
      <div className="flex flex-col gap-10 p-10">
        <G4SustainAnalyticsEditCard
          id={Number(id)}
          client={Clients.G4}
          table_name={Tables.G4_SUSTAINALYTICS_ESG}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.G4}
          audit_table_name={Tables.G4_SUSTAINALYTICS_ESG}
        />
      </div>
    </div>
  );
};
